import { CircleCheck, Info, TriangleAlert } from 'lucide-react'
import type { ReactNode } from 'react'

type Tone = 'critical' | 'warning' | 'info' | 'success'

const COLOR: Record<Tone, string> = {
  critical: 'rgb(var(--ignition))',
  warning: 'rgb(var(--flare))',
  info: 'rgb(var(--clear))',
  success: 'rgb(var(--stable))',
}
const ICON = { critical: TriangleAlert, warning: TriangleAlert, info: Info, success: CircleCheck }

/** Tinted callout — full tinted border + wash, no left accent rail. */
export function Alert({
  tone,
  title,
  children,
  action,
}: {
  tone: Tone
  title: ReactNode
  children?: ReactNode
  /** Optional controls (buttons/links) rendered under the message. */
  action?: ReactNode
}) {
  const c = COLOR[tone]
  const Icon = ICON[tone]
  return (
    <div
      className="flex items-start gap-3 rounded-md border p-3 text-sm"
      style={{
        borderColor: `color-mix(in srgb, ${c} 45%, transparent)`,
        background: `color-mix(in srgb, ${c} 9%, transparent)`,
      }}
    >
      <Icon className="mt-px size-[18px] shrink-0" style={{ color: c }} />
      <div className="min-w-0 flex-1">
        <div className="font-semibold">{title}</div>
        {children && <div className="mt-0.5 text-[12.5px] text-muted-foreground">{children}</div>}
        {action && <div className="mt-2.5 flex flex-wrap items-center gap-2">{action}</div>}
      </div>
    </div>
  )
}
